export const ExperienceStopStates = {
	TASK_FAIL: 'taskFail',
	TASK_SUCCESS: 'taskSuccess',
	TASK_ABORT: 'taskAbort',
} as const;
